import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  Dialog: {
    backgroundColor: '#fff',

    '& h4': {
      color: '#545454',
      fontWeight: 'bold',
    },
  },
  dialogAction: {
    padding: '8px 24px',
    paddingBottom: 30,
    backgroundColor: '#fff',
    '& button:first-of-type': {
      backgroundColor: '#fff',
      border: 'solid 1.5px #4a4a4a',
      '& span': {
        color: '#5e5e5e',
      },
    },
    '& button:last-of-type': {
      backgroundColor: '#4abc4e',
      '& span': {
        color: '#fff',
        padding: '0px 30px',
      },
      '& span:first-of-type': {
        zIndex: 1,
      },
      '&.active span': {
        backgroundColor: '#4abc4e!important',
        border: '1px solid #4abc4e',
      },
    },
    '& button:last-of-type:hover': {
      boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)',
    },
  },
  root: {
    flexGrow: 1,

    '& .Mui-disabled': {
      backgroundColor: '#d5d5d5',
    },
  },
  formAdd: {
    backgroundColor: '#fff',
    width: 800,

    '& span': {
      color: '#393060',
      fontWeight: 600,
      fontFamily: 'AvenirNext',
    },
    '& i': {
      color: '#4a90e2',
    },
  },
  GeoCode: {
    backgroundColor: '#8192a7 !important',
    '& span': {
      color: '#fff',
      padding: 2,
    },
  },
  addBtn: {
    backgroundColor: '#cccccc',
    color: 'red',
  },
  closeBtn: {
    position: 'absolute',
    right: 20,
    top: 15,
    color: '#d8d8d8',
    fontSize: 30,
    cursor: 'pointer',
  },
  description: {
    fontSize: 12,
    marginLeft: 3,
    marginTop: 5,
    marginBottom: 0,
  },
  required: {
    fontSize: 'smaller',
    color: 'red !important',
    fontStyle: 'Italic',
    marginLeft: 5,
  },
  cancelBtn: {
    color: 'black',
    minWidth: 120,
  },
}));
